import { render, staticRenderFns } from "./yuTeam.vue?vue&type=template&id=2dddcfb4&scoped=true&"
import script from "./yuTeam.vue?vue&type=script&lang=js&"
export * from "./yuTeam.vue?vue&type=script&lang=js&"
import style0 from "./yuTeam.vue?vue&type=style&index=0&id=2dddcfb4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dddcfb4",
  null
  
)

export default component.exports